/**
 * Gutenberg Blocks
 *
 * All blocks related JavaScript files should be imported here.
 * You can create a new block folder in this dir and include code
 * for that block here as well.
 *
 * All blocks should be included here since this is the file that
 * Webpack is compiling as the input file.
 */
/*jshint esversion: 6 */
import './block/popup-block.js';
import './block/slidein-block.js';
import './block/embed-block.js';
